import { render } from "./cafeItemHeader.vue?vue&type=template&id=1244a11b&scoped=true"
import script from "./cafeItemHeader.vue?vue&type=script&lang=js"
export * from "./cafeItemHeader.vue?vue&type=script&lang=js"

import "./cafeItemHeader.vue?vue&type=style&index=0&id=1244a11b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1244a11b"]])

export default __exports__